import { Injectable } from '@angular/core';
import { FacettenUrlService } from '../facetten.url.service';

@Injectable({
  providedIn: 'root'
})
export class BeginnterminUrlService extends FacettenUrlService {
  public static URL_PARAMETER = 'bt';

  constructor() {
    super(BeginnterminUrlService.URL_PARAMETER, 'bt');
  }
}
